import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { CloseIcon } from '@paypalcorp/pp-react-icons';
import { css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { textStyles } from '@paypalcorp/pp-react-text';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function pillStyles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    // eslint-disable-next-line no-console
    console.warn('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysColorBackgroundSurface = tokens.sysColorBackgroundSurface,
      sysColorSelectedRangeMain = tokens.sysColorSelectedRangeMain,
      sysColorSelectedRangeContrast = tokens.sysColorSelectedRangeContrast,
      sysSpaceTiny = tokens.sysSpaceTiny,
      sysSpaceXs = tokens.sysSpaceXs,
      sysSpaceSm = tokens.sysSpaceSm,
      sysSpaceLg = tokens.sysSpaceLg;
  var pill = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: pill;\n    background-color: ", ";\n    padding-block: 0 0;\n    padding-inline: ", " 0;\n    white-space: nowrap;\n    border-radius: 100px;\n    position: relative;\n    display: inline-grid;\n    grid-gap: ", ";\n    grid-template-columns: 1fr auto;\n    place-items: center;\n  "])), sysColorSelectedRangeMain, sysSpaceLg, sysSpaceXs);

  var _textStyles = textStyles(tokens),
      captionStrong = _textStyles.captionStrong;

  var pillLabel = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    label: pill_label;\n    ", "\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  "])), captionStrong({
    color: sysColorSelectedRangeContrast
  }));
  var buttonSpace = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    label: btn_space;\n    margin: ", ";\n  "])), sysSpaceTiny);
  var pillTray = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    label: pill_tray;\n    background-color: ", ";\n  "])), sysColorBackgroundSurface);
  var pillTrayScroller = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    label: pill_scroll;\n    overflow-x: scroll;\n    margin: 0;\n    padding: ", " ", " ", ";\n    display: flex;\n    column-gap: ", ";\n  "])), sysSpaceSm, sysSpaceSm, sysSpaceLg, sysSpaceSm);
  return {
    pill: pill,
    pillLabel: pillLabel,
    buttonSpace: buttonSpace,
    pillTray: pillTray,
    pillTrayScroller: pillTrayScroller
  };
}

var _excluded = ["as", "value", "className", "dismissButtonLabel", "onDismiss", "children"];

var Pill = function Pill(_ref) {
  var _ref$as = _ref.as,
      Component = _ref$as === void 0 ? 'div' : _ref$as,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 'value' : _ref$value,
      className = _ref.className,
      _ref$dismissButtonLab = _ref.dismissButtonLabel,
      dismissButtonLabel = _ref$dismissButtonLab === void 0 ? 'dismiss' : _ref$dismissButtonLab,
      onDismiss = _ref.onDismiss,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);
  /* istanbul ignore next */


  if (!onDismiss) {
    onDismiss = function onDismiss() {
      return console.warn('Required prop `onDismiss` is missing');
    };
  }

  var tokens = useTheme();
  var styles = pillStyles(tokens);

  var handleClick = function handleClick(evt) {
    var target = evt.target;
    onDismiss(target.dataset.value);
  };

  return jsx(Component, _extends({
    css: styles.pill,
    role: "listitem",
    className: className
  }, rest, {
    "data-ppui": "true"
  }), jsx("label", {
    css: styles.pillLabel,
    "data-ppui": "true"
  }, children), jsx(IconButton, {
    buttonType: "tertiary",
    size: "sm",
    css: styles.buttonSpace,
    "data-value": value,
    svgIconComponent: CloseIcon,
    onClick: handleClick,
    "data-ppui": "true"
  }, dismissButtonLabel));
};

var PillTray = function PillTray(_ref) {
  var children = _ref.children;
  var tokens = useTheme();

  var _pillStyles = pillStyles(tokens),
      pillTray = _pillStyles.pillTray,
      pillTrayScroller = _pillStyles.pillTrayScroller;

  return jsx("div", {
    css: pillTray,
    "data-ppui-info": "pill_2.2.13"
  }, jsx("div", {
    css: pillTrayScroller,
    role: "list",
    "data-ppui": "true"
  }, children));
};

export { Pill, PillTray, pillStyles };